<template>
  <div class="BaseTemplateItemImageSetting">
    <div class="flex items-center gap-xs q-mb-md">
      <h2 class="q-my-none text-cool-gray-100 fs-17px fw-500 text-capitalize">
        {{ t('contents.images.setting_title') }}
      </h2>

      <k-callout
        :title="t('contents.images.info.title')"
        has-alert-icon
        :description="t('contents.images.info.description')"
      />
    </div>

    <k-radio v-model="valueType" :label="t('contents.images.upload_local_image')" val="local" />

    <div v-if="valueType === 'local'" class="q-mt-12">
      <BaseUploader
        id="receipt_uploader"
        v-model="images"
        v-model:new-image="newImage"
        :max-item="1"
        placeholder-type="bill"
        :placeholder-src="placeholderImage"
        accept="image/jpeg"
        no-crop
        @update:new-image="handleTemplateImage"
        @on-delete="handleRemoveImage"
      />
    </div>

    <k-alert
      v-if="templateStore.isPrintTemplate"
      class="q-mt-md"
      model="warning"
      :title="t('contents.images.warning.title')"
      :description="t('contents.images.warning.description')"
    />

    <!-- <k-radio v-model="valueType" class="q-mt-md" label="Connect Image to Data Field" val="field" disable /> -->

    <k-divider class="q-my-md" size="md" color="cool-gray-40" />

    <h2 class="q-mt-none q-mb-md text-cool-gray-100 fs-17px fw-500">{{ t('contents.styles.setting_title') }}</h2>

    <BaseTemplateItemTransformSetting />

    <div class="flex no-wrap items-center justify-between gap-sm q-mt-sm">
      <span class="fw-500 fs-15px text-cool-gray-80 flex-1">{{ t('contents.styles.corner_radius') }}</span>
      <k-input
        small
        root-class="BaseTemplateItemImageSetting__input"
        :model-value="templateStore.activeItem.radius"
        :has-clear-icon="false"
        input-class="text-center"
        @update:model-value="templateStore.handleUpdateItemSetting('radius', +$event)"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'
import { useTemplateStore } from 'src/stores'
import BaseTemplateItemTransformSetting from './BaseTemplateItemTransformSetting'
import translate from 'src/common/helpers/language/translate'
import translationObject from '../../translate/baseTemplate.translate'
import addImage from 'src/assets/add-image.svg'
import placeholderImage from 'src/assets/default-image.svg'

defineOptions({ name: 'BaseTemplateItemImageSetting' })

const templateStore = useTemplateStore()
const { t } = translate(translationObject)

const valueType = ref('local')
const image = ref(
  templateStore.newUploadImages[templateStore.activeItem.id]?.file ??
    `${templateStore.activeItem.value}?t=${Date.now()}`,
)
const images = ref(image.value ? [image.value] : [])
const newImage = ref(
  templateStore.newUploadImages[templateStore.activeItem.id]?.file
    ? [templateStore.newUploadImages[templateStore.activeItem.id].file]
    : [],
)

watch(
  () => templateStore.activeItem,
  () => {
    image.value =
      templateStore.newUploadImages[templateStore.activeItem.id]?.file ??
      `${templateStore.activeItem.value}?t=${Date.now()}`
    images.value = image.value ? [image.value] : []
    newImage.value = templateStore.newUploadImages[templateStore.activeItem.id]?.file
      ? [templateStore.newUploadImages[templateStore.activeItem.id].file]
      : []
  },
)

function handleTemplateImage($event) {
  if (Array.isArray($event) && $event.length)
    templateStore.handleSetNewImage({
      id: templateStore.activeItem.id,
      blob: URL.createObjectURL($event[0]),
      file: $event[0],
    })
}

function handleRemoveImage() {
  const blob = new Blob([addImage], { type: 'image/svg+xml' })
  const file = new File([blob], 'image.jpeg', { type: 'image/jpeg' })

  templateStore.handleSetNewImage({
    id: templateStore.activeItem.id,
    blob: URL.createObjectURL(file),
    file,
  })
}
</script>

<style lang="sass" scoped>
@import "src/shared/styles/mixins.sass"

.BaseTemplateItemImageSetting
  @include element('input')
    width: 106px
</style>
